const PropTypes = require('prop-types');
/**
 * Created by adderlyjaureguicampos on 07/12/16.
 */
const React = require('react');

const PoliticalChargeDescription = require('../PoliticalChargeDescription/PoliticalChargeDescription');

const { OKCheckbox } = require('commonsComponents/OKCheckbox');

class PoliticalChargeCountry extends React.Component {

    constructor(props) {
        super(props);
        this.onTextareaChange = this.onTextareaChange.bind(this);
    }

    onTextareaChange(event) {
        this.props.handleTextareaChange(event);
    }

    render() {
        const options = this.props.politicalChargeCountryOptions.map( (option, index) => {
            return (
                <div key={index}>
                    <OKCheckbox
                        key={index}
                        idName={option.id}
                        label={option.label}
                        value={option.value}
                        onChange={this.props.handleCheckboxChange}
                    />
                </div>
            )
        });
        const showPoliticalChargeDescription = this.props.state.politicalCountrySpainSelected || this.props.state.politicalCountryForeignSelected ?
            (<PoliticalChargeDescription
                state={this.props.state}
                handleTextareaChange={this.onTextareaChange}
            />) : null;
        return (
            <div className="political-charge__form-element">
                <div className="political-charge__form-element">
                    {options}
                </div>
                <div className="political-charge__form-element">
                    {showPoliticalChargeDescription}
                </div>
            </div>
        );


    }
}

PoliticalChargeCountry.propTypes = {
    state: PropTypes.object,
    politicalChargeCountryOptions: PropTypes.array,
    handleCheckboxChange: PropTypes.func,
    handleTextareaChange: PropTypes.func,
    values: PropTypes.object
};

module.exports = PoliticalChargeCountry;